import React from 'react';

export default class ShareButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status: false,
            copyStatus: false,
        }
        this.inputRef = React.createRef();
    }

    _setStatus() {
        this.setState(state => {
            return {
                status: true,
            }
        })
    }

    _copyLink() {
        this.setState(state => {
            return {
                copyStatus: true
            }
        })
        let copyText = this.inputRef.current;
        navigator.clipboard.writeText(copyText.value);
    }

    render() {
        return (
            <div className={`second-stage__share ${this.state.status ? 'second-stage__share--active' : ''}`}>
                <div className='second-stage__link-icon'>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.379 8.1905L3.14554 10.424C2.31141 11.2581 1.83173 12.3931 1.8405 13.5859C1.84926 14.7787 2.31844 15.9206 3.19216 16.7673C4.03884 17.641 5.18097 18.1102 6.37359 18.119C7.59342 18.1279 8.70152 17.6753 9.5357 16.8411L11.7692 14.6077M14.622 11.8094L16.8554 9.57597C17.6896 8.74183 18.1692 7.60687 18.1605 6.41406C18.1517 5.22124 17.6825 4.07936 16.8088 3.23262C15.9623 2.38614 14.8204 1.91693 13.6276 1.90816C12.4348 1.8994 11.2997 2.35185 10.4655 3.18601L8.23201 5.41946M6.61359 13.3271L13.314 6.62676" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </div>
                <input ref={this.inputRef} defaultValue={this.props.copyLink} className='second-stage__share-input'/>
                <button 
                    onClick = {() =>{this.state.status ? this._copyLink() : this._setStatus()}}
                    onTouchStart = {() => {this.state.status ? this._copyLink() : this._setStatus()}}
                    className={`button button--share second-stage__share-button ${this.state.copyStatus ? 'second-stage__share-button--active' : ''}`}
                >
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.80039 1.3999H5.00039C3.01217 1.3999 1.40039 3.01168 1.40039 4.9999V17C1.40039 18.9882 3.01217 20.6 5.00039 20.6H17.0004C18.9886 20.6 20.6004 18.9882 20.6004 17V12.1999M14.5998 1.40019L20.6004 1.3999M20.6004 1.3999V6.80005M20.6004 1.3999L10.3995 11.5996" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {!this.state.status ? 'Поделиться' : !this.state.copyStatus ? 'Копировать' :  window.innerWidth > 768 ?'Ссылка скопирована' : 'Скопировано'}
                </button>
            </div>)
    }
}